/**
 * Constants for ticket identifier search types
 * Used in the AllTabFilters component for filtering tickets by various identifier types
 */

export const IDENTIFIER_TYPES = {
  SIMPLR_TICKET: 'simplr_ticket',
  WIDGET_ID: 'widget_id',
  ROOM_ID: 'room_id',
  PLATFORM_TICKET_ID: 'platform_ticket_id',
};

/**
 * Display labels for identifier types
 * Used in dropdown options and UI labels
 */
export const IDENTIFIER_TYPE_LABELS = {
  [IDENTIFIER_TYPES.SIMPLR_TICKET]: 'Simplr ticket #',
  [IDENTIFIER_TYPES.WIDGET_ID]: 'Widget ID',
  [IDENTIFIER_TYPES.ROOM_ID]: 'Room ID',
  [IDENTIFIER_TYPES.PLATFORM_TICKET_ID]: 'Platform ticket ID',
};

/**
 * Identifier type options for dropdown
 * Array format for use with DropDown component
 */
export const IDENTIFIER_TYPE_OPTIONS = [
  {
    id: IDENTIFIER_TYPES.SIMPLR_TICKET,
    label: IDENTIFIER_TYPE_LABELS[IDENTIFIER_TYPES.SIMPLR_TICKET],
  },
  {
    id: IDENTIFIER_TYPES.WIDGET_ID,
    label: IDENTIFIER_TYPE_LABELS[IDENTIFIER_TYPES.WIDGET_ID],
  },
  {
    id: IDENTIFIER_TYPES.ROOM_ID,
    label: IDENTIFIER_TYPE_LABELS[IDENTIFIER_TYPES.ROOM_ID],
  },
  {
    id: IDENTIFIER_TYPES.PLATFORM_TICKET_ID,
    label: IDENTIFIER_TYPE_LABELS[IDENTIFIER_TYPES.PLATFORM_TICKET_ID],
  },
];

/**
 * Default identifier type selection
 */
export const DEFAULT_IDENTIFIER_TYPE = IDENTIFIER_TYPES.SIMPLR_TICKET;
